import { IconKeys } from '../Icon/IconKeys';
import ImageWithFallback from '../ImageWithFallback/ImageWithFallback';
import Tags from '../Tags';
import S from './ExpandedItemStyles';
import { generateScoreColor, generateVehicleStatusColor, getScoreLabel } from '../../../utils/commonUtils';
import { VehicleStatus } from '../../../constants/VehicleStatus';
import { ThemeType } from '../../../theme/themeType';

export const renderTitle = (type: string): string => {
  switch (type) {
    case 'device':
      return 'Device';
    case 'alert':
      return 'Last alert';
    case 'driver':
      return 'Driver';
    case 'vehicle':
      return 'Vehicle';
    default:
      return 'Default title';
  }
};

export const renderContent = (type: string, item: any):JSX.Element => {
  switch (type) {
    case 'device':
      return <S.DeviceImageWrapper src={item?.image} alt="device-preview" />;
    case 'driver':
      return (
        <S.OverviewWrapper>
          <ImageWithFallback src={item?.image} className="driver-img" alt="driver-preview" />
          <p className="label"> {item?.name} </p>
          <p className="description"> {item?.title} </p>
        </S.OverviewWrapper>
      );
    case 'vehicle':
      return (
        <S.OverviewWrapper>
          <img src={item?.image} className="vehicle-img" alt="vehicle-preview" />
          <p className="label"> {item?.name} </p>
          <p className="description"> {item?.title} </p>
        </S.OverviewWrapper>
      );
    default:
      return <p>No content</p>;
  }
};

export const renderTags = (type: string, item: any, theme: ThemeType):JSX.Element => {
  switch (type) {
    case 'device':
      return (
        <>
          {!!item?.status && (
            <Tags.Status
              label={item?.status}
              backgroundColor={
                item?.status?.toLowerCase() === 'online' ? theme.colors.green : theme.colors.red
              }
            />
          )}
          {!!item?.configDisplay && (
            <Tags.LabeledIcon
              label={item.configDisplay.text}
              icon={item.configDisplay.icon}
              backgroundColor={item.configDisplay.color}
              textColor={item.configDisplay.textColor}
              flexible
            />
          )}
          {!!item?.deviceId && <Tags.Label label={item?.deviceId} />}
          {!!item?.hwModel && <Tags.Label label={item?.hwModel} />}
          {!!item?.fwVersion && <Tags.Label label={item?.fwVersion} />}
          {!!item?.lastActivityLabel && <Tags.LabeledIcon flexible label={item.lastActivityLabel} icon={IconKeys.TIME} />}
        </>
      );
    case 'driver':
      return (
        <>
          {(!Number.isNaN(item?.score) && item?.score >= 0) ? (<Tags.Status label={`${getScoreLabel(item?.score)} in total`} backgroundColor={generateScoreColor(item?.score)} />) : (<Tags.Status label="No score" backgroundColor={theme.colors.outline} />)}
          <Tags.Status
            label={item?.licenseCheck ? item.licenseCheck : 'No license status'}
            backgroundColor={theme.colors.inactive}
            title="License status"
          />
          {!!item?.mileage && <Tags.LabeledIcon label={item.mileage} icon={IconKeys.DISTANCE} />}
          {!!item?.eventsLabel && <Tags.LabeledIcon flexible label={item.eventsLabel} icon={IconKeys.ALERT_CIRCLE} />}
          {/* {!!item?.vehicleClassType && <Tags.LabeledIcon flexible label={item?.vehicleClassType ? `License issued for ${item.vehicleClassType}` : 'Vehicle class type: N/A'} icon={IconKeys.CAR_OUTLINED} />} */}
        </>
      );
    case 'vehicle':
      return (
        <>
          {(!Number.isNaN(item?.score) && item.score >= 0) ? (<Tags.Status label={`${getScoreLabel(item?.score)} in total`} backgroundColor={generateScoreColor(item?.score)} />) : (<Tags.Status label="No score" backgroundColor={theme.colors.outline} />)}
          <Tags.Status
            label={item?.status ? VehicleStatus[item.status as keyof typeof VehicleStatus] : 'No driving status'}
            backgroundColor={generateVehicleStatusColor(item?.status)}
          />
          {!!item?.mileage && <Tags.LabeledIcon label={item.mileage} icon={IconKeys.DISTANCE} />}
          {!!item?.eventsLabel && <Tags.LabeledIcon flexible label={item.eventsLabel} icon={IconKeys.ALERT_CIRCLE} />}
          {!!item?.category && item.category === 'car' && <Tags.LabeledIcon label={item?.category.toUpperCase()} icon={IconKeys.CAR_OUTLINED} />}
          {!!item?.category && item.category === 'minibus' && <Tags.LabeledIcon label={item?.category.toUpperCase()} icon={IconKeys.CAR_HATCHBACK} />}
          {!!item?.category && item.category === 'truck' && <Tags.LabeledIcon label={item?.category.toUpperCase()} icon={IconKeys.TRUCK} />}
        </>
      );
    default:
      return <Tags.Label label="No tags" />;
  }
};
